import { TextField } from '@mui/material'
import { useDispatch } from 'react-redux'
import { useSelector } from 'src/utils/store'
import { actions } from '../../ReceivementOverviewListState'

export const ArNumberFilterInput = () => {
  const dispatch = useDispatch()
  const idAr = useSelector((state) => state.receivementOverviewList.idAr)

  const setIdAr = (event: React.ChangeEvent<{ value: string }>) => {
    const { value } = event.target
    dispatch(actions.updateOverviewFilterField({ key: 'idAr', value }))
  }

  return (
    <TextField
      autoComplete='off'
      label='Nº AR'
      variant='outlined'
      size='small'
      onKeyPress={(e) => !/[0-9]|Enter/.test(e.key) && e.preventDefault()}
      fullWidth
      value={idAr}
      onChange={setIdAr}
      inputProps={{ 'data-testid': 'id-ar-input' }}
    />
  )
}
